export const environment = {
  production: true,
  ENV: {
    name:"dev",
   // apiBaseUrl: "https://dev.api.grade5.lk/v1/",//dev
    apiBaseUrl: "https://api.grade5.lk/v1/", // qa
    // apiBaseUrl: "https://uat.api.grade5.lk/v1/",
    //  apiBaseUrl: "http://10.0.0.32:3000/v1/",//sachini
    //
   //apiBaseUrl: "http://localhost:3000/v1/",
   // apiBaseUrl: "https://dev.api.grade5.lk/v1/",

    clientAppUrl: 'https://www.grade5.lk/',
    resourceUrl: "https://s3-ap-southeast-1.amazonaws.com/grade5bkt/paperimages/",
    androidAppName: 'grade5://paper-sets',
    mobileRedirectUrl: 'grade5://grade5.lk',
    version: "2.51.13",
    localization: true
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/environments/environment.ts